import {useEffect, useRef} from "react"
import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"
import {useLexiconsContext} from "../../reactContext/contextCustomHooks/useLexiconsContext"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"
import {useStWorkflowContext} from "../../reactContext/contextCustomHooks/useStWorkflowContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"
import {useEcpWorkflowContext} from "../../reactContext/contextCustomHooks/useEcpWorkflowContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useTranslation} from "react-i18next"
import ScrollingMod from "../../tools/ScrollingMod"
import useClickOutside from "../../tools/useClickOutside"

export default function ConfirmationModal({
    type,
    setDeleteConfirmation,
    deleteLicence,
    deleteTeamUser,
    deleteStProject,
    restoreStProject,
    deleteEcpProject,
    restoreEcpProject,
    exportStProject,
    generateEcpProject,
    deleteGlossaryTerm,
    finalizeEcpProject,
    modalMessage}) {

    const {t} = useTranslation()
    const {setNwDashboardAction} = useNwDashboardContext()
    const {setLexiconsAction} = useLexiconsContext()
    const {stProjectsContext, setStProjectsAction} = useStProjectsContext()
    const {setStWorkflowAction} = useStWorkflowContext()
    const {ecpProjectsContext, setEcpProjectsAction} = useEcpProjectsContext()
    const {setEcpWorkflowAction} = useEcpWorkflowContext()
    const {setTeamAction} = useTeamContext()
    const confirmationModalRef = useRef(null)

    useClickOutside(confirmationModalRef, () => {
        handleClick(false)
    })

    const handleClick = (value) => {
        switch (type) {
            case "st-projects":
                (stProjectsContext.isConfirmationModal.action === "restore" ? restoreStProject(value) : deleteStProject(value))
                .then(() => {
                    setStProjectsAction({type: "ST_PROJECTS_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: false, id: null, action: null}}})
                })
                break
            case "st-export":
                exportStProject(value)
                .then(() => {
                    setStWorkflowAction({type: "ST_WORKFLOW_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: false, id: null}}})
                })
                break
            case "ecp-projects":
                (ecpProjectsContext.isConfirmationModal.action === "restore" ? restoreEcpProject(value) : deleteEcpProject(value))
                .then(() => {
                    setEcpProjectsAction({type: "ECP_PROJECTS_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: false, id: null, action: null}}})
                })
                break
            case "ecp-generate":
                generateEcpProject(value)
                .then(() => {
                    setEcpWorkflowAction({type: "ECP_WORKFLOW_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: false, id: null, type: null}}})
                })
                break
            case "delete-glossary-term":
                deleteGlossaryTerm(value)
                .then(() => {
                    setEcpWorkflowAction({type: "ECP_WORKFLOW_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: false, id: null, type: null}}})
                })
                break
            case "ecp-export":
                finalizeEcpProject(value)
                .then(() => {
                    setEcpWorkflowAction({type: "ECP_WORKFLOW_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: false, id: null, type: null}}})
                })
                break
            case "lexicons":
                setDeleteConfirmation(value)
                setLexiconsAction({type: "CLEAN_LEXICONS_CONTEXT"})
                break
            case "teams":
                deleteTeamUser(value)
                .then(() => {
                    setTeamAction({type: "TEAM_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: false, id: null, action: null}}})
                })
                break
            case "team":
                deleteLicence(value)
                .then(() => {
                    setNwDashboardAction({type: "NW_DASHBOARD_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: false, id: null, action: null}}})
                })
                break
            default:
                break
        }
        ScrollingMod(false)
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        ScrollingMod(true)
    }, [])

    return (
        <>
        <div ref={confirmationModalRef} className="confirmation-modal">
            <div className="content">
                <p>{t(modalMessage ? modalMessage : "Do you want to confirm this action?")}</p>
                <div className="actions">
                    <button className="cancel-btn" onClick={() => handleClick(true)}>{t("Yes")}</button>
                    <button className="confirm-btn" onClick={() => handleClick(false)}>{t("No")}</button>
                </div>
            </div>
        </div>
        </>
    )
}